import { useConfigurationStore } from '@stores/configurationStore'
import { useEffect, useRef } from 'react'
import { useMessageData } from '@hooks'
import { useMenuStore } from '@stores'

const Information = () => {
    const paytableUrl = useConfigurationStore((state) => state.paytableUrl)
    const paytableData = useConfigurationStore((state) => state.paytableData)
    const currentSelectedTabIndex = useMenuStore((state) => state.currentSelectedTabIndex)

    const iframeRef = useRef<HTMLIFrameElement | null>(null)
    const hasSentData = useRef(false)

    const getIframeData = () => {
        if (iframeRef.current && !hasSentData.current) {
            const payload = {
                ...paytableData,
            }

            ;(iframeRef.current as HTMLIFrameElement).contentWindow?.postMessage({ type: 'paytableData', payload }, '*')

            hasSentData.current = true
        }
    }

    useMessageData(({ type }) => {
        if (type === 'readyForPaytableData') {
            getIframeData()
        }
    }, [])

    // This is a workaround for a Safari compositing bug: iframe content turns black
    // after being hidden (display:none) and shown again when info tab is selected.
    // This forces Safari to repaint the iframe.
    useEffect(() => {
        if (iframeRef.current) {
            try {
                const contentWindow = iframeRef.current.contentWindow

                contentWindow?.postMessage({ type: 'scrollTo', payload: { top: 0 } })
                contentWindow?.scrollTo({ top: 0 })
            } catch {
                /* empty */
            }
        }
    }, [currentSelectedTabIndex])

    return (
        <div className="relative w-full h-full">
            <iframe
                ref={iframeRef}
                src={paytableUrl}
                className="absolute inset-0 w-full h-full border-none"
                onLoad={getIframeData}
                id="information-iframe"
            ></iframe>
        </div>
    )
}

export default Information
